import React, { Component, createRef } from "react";
import {
    Form,
    Navbar,
    Nav,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from "reactstrap";
import EventEmitter, { Events } from "../../services/eventemitter";
import SettingModal from "../../constants/SettingsModal";
import { Menu, Coffee, LogOut, Key, Settings, Grid, Flag, RefreshCcw } from "react-feather";
import { wglcsApiService } from "../../services/WglcsApiService";
import { loginService } from "../../services/loginService";
import {
    ContentModel,
    LoginResponse,
    MonitoringPanelTypes,
    RoleInterface,
    SurveyQuestionsForUserModel,
    UnSentChatsModel,
    WentAwayUsers,
    XmppSessionType,
    monitoringPanelLink,
    wgLogType,
    wgModules
} from "../../models";
import { OperatorPanelRoute } from "../sidebar/sidemenu";
import { notificationService } from "../../services/PushNotificationService";
import { xmppChatService } from "../../services/XmppChatService";
import { BreakStatus, ConnectionStatus } from "../../models/connectionStatus";
// import Cookies from "universal-cookie";
import { utils } from "../../utils/index";
import { ResponseMessage } from "../../constants/ResponseMessages";
import ReportABug from "./ReportABug";
import ChangePasswordModal from "./ChangePasswordModal";
import LogoutModal from "./LogoutModal";
import UnSentChatsPopup from "./UnSentChatsPopup";
import SnackBar from "../../views/alert/Toast";
import { cacheService } from "../../services/cacheService";
import Marquee from "react-fast-marquee";
import { chatService } from "../../services/chatService";
import { signalRChatService } from "../../services/SignalRChatService";
import { LocalStorageService } from "../../services/localStorageService";
import { Ripple } from "primereact/ripple";
import { t } from "i18next";
import RefereshApi from "../../components/refereshApi/refereshApi.component";
import { cookieService } from "../../services/CookieService";
import SurveyQuestionTimer from "../../components/GlobalTimers/SurveyQuestionTimer";
import { DetectEnvironment } from "../../EnvironmentSettings";
import { Toast } from "primereact/toast";
import { sessionStorageService } from "../../services/SessionStorageService";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { reportsScreenSubRoutes } from "../../views/WgReportSubMenu/ReportsSidebar";
import { debounce } from "lodash";
import { wgLogs } from "../../constants/wgLogs";
import { userService } from "../../services/userService";
// import MemoryStats from "./MemoryStats";

const { detect } = require("detect-browser");
const browser = detect();

interface NavigationBarProps {
    toggleSidebarMenu: (state: boolean) => void;
    maskLayout: (state: boolean) => void;

}

interface NavigationBarState {
    userData: LoginResponse;
    isOperatorOnBreak: boolean;
    showLogoutModal: boolean;
    showChangePasswordModal: boolean;
    showSettingsModal: boolean;
    showSurveyQuestionsModal: boolean;
    showReportBugModal: boolean;
    connectionStatus: ConnectionStatus;
    internetConnectionStatusMessage: string;
    currentPath: string;
    BreakTitle: string;
    endBreakTitle: string;
    toggle: boolean;
    showUnSentChatModal: boolean;
    unSentChats: UnSentChatsModel[];
    openSnackBar: boolean;
    responseMessage: string;
    severity: string;
    showPendingSurvey: boolean;
    notificationMessage: string;
    SignalRconnectionStatus: ConnectionStatus;
    sessionExpiredAlert: boolean;
    showUpdateModal: boolean;
    IsSessionExpireNotificationEnabled: boolean;
    breakStatus: BreakStatus;
    runningChatsCount: number;
    MonitoringPanelType: string;
    onLogOutMode: boolean;
    internetConnectivity: boolean;
    unSentChatsCount: any;
    surveyChatCount: any;
    isChildWindow: boolean;
    sessionExpireMessage: string;
    videoAlert: boolean;
    videoAlertMsg: string,
    videoAlertSeverty: string,
    videoStartTime: any,
    videoEndTime: any,
    timerInterval: any,
    callStarted: boolean,
    elapsedTime: any,
    callEndTimer: any,
    hideCallAlertInterval: any,
    isPlaying: boolean;
    showPopUpPermissionModal: boolean
}

// const cookies = new Cookies();

class NavigationBar extends Component<NavigationBarProps, NavigationBarState> {
    private audioRef: React.RefObject<HTMLAudioElement>;
    toast: Toast | null = null;
    timerId!: NodeJS.Timeout;
    IsLogIDAliveInterval!: NodeJS.Timeout;
    newUpdateInterval!: NodeJS.Timeout;
    unSentChatInterval!: NodeJS.Timeout;
    sessionExpireInterval!: NodeJS.Timeout;
    breakInterval!: NodeJS.Timeout;
    speechSynthesis = window.speechSynthesis;
    BPSMessages: any = [];
    breakId: number = 0;
    logs: any = [];
    checkSignalRConnectionCount: number = 0;
    routePaths = new Map<string, boolean>([
        ["/dashboard", false],
        ["/chat/:chatid", false],
        ["/hybridChat", false],
        ["/logged-in-resources", false],
        ["/monitoringPanel", false],
        ["/resourcesPool/personal-information", false],
        ["/Point-System", false],
        ["/WebsiteService-Status", false],
    ]);

    connectionStateColorMap: Map<ConnectionStatus, string> = new Map([
        [ConnectionStatus.Disconnected, "red"],
        [ConnectionStatus.Connected, "green"],
        [ConnectionStatus.Connecting, "yellow"],
    ]);

    constructor(props) {
        super(props);
        var userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;
        this.audioRef = createRef<HTMLAudioElement>();
        this.state = {
            userData: userData,
            isOperatorOnBreak: false,
            showLogoutModal: false,
            showChangePasswordModal: false,
            connectionStatus: ConnectionStatus.Disconnected,
            showSettingsModal: false,
            currentPath: "",
            BreakTitle: t("Take a Break"),
            endBreakTitle: "",
            showSurveyQuestionsModal: false,
            internetConnectionStatusMessage: "",
            showReportBugModal: false,
            toggle: false,
            showUnSentChatModal: false,
            unSentChats: [],
            openSnackBar: false,
            responseMessage: "",
            severity: "",
            showPendingSurvey: false,
            notificationMessage: "",
            SignalRconnectionStatus: ConnectionStatus.Disconnected,
            sessionExpiredAlert: false,
            showUpdateModal: false,
            IsSessionExpireNotificationEnabled: false,
            breakStatus: BreakStatus.End,
            runningChatsCount: 0,
            MonitoringPanelType: "",
            onLogOutMode: false,
            internetConnectivity: true,
            unSentChatsCount: 0,
            surveyChatCount: 0,
            isChildWindow: false,
            sessionExpireMessage: t("Session.message"),
            videoAlert: false,
            videoAlertMsg: "",
            videoAlertSeverty: "",
            videoStartTime: "",
            videoEndTime: "",
            timerInterval: null,
            callStarted: false,
            elapsedTime: 0,
            callEndTimer: null,
            hideCallAlertInterval: null,
            isPlaying: false,
            showPopUpPermissionModal: false
        };

        this.internetConnectivityNotify()
        this.unSentChatNotify()
        this.surveyCountNotify()
        this.loadUnsentChats();

        EventEmitter.on(Events.onBreakTitle, this.getBreakTitle);
        EventEmitter.on(Events.videoStatus, this.videoStatus);
        EventEmitter.on(Events.preventCall, this.preventCall);
        EventEmitter.on(Events.onNewNotification, this.onNewNotification);
        EventEmitter.on(Events.onInternetConnectionChange, this.onInternetConnectionChange);
        // EventEmitter.on(Events.onGetUnSentChat, this.GetUnsentChats);
        EventEmitter.on(Events.getLoadedData, this.getLoadedData);
        EventEmitter.on(Events.notificationText, this.getNotificationText);
        EventEmitter.on(Events.strophConnectionStatus, this.strophConnectionStatus);
        EventEmitter.on(Events.signalRConnectionStatus, this.signalRConnectionStatus);
        EventEmitter.on(Events.persistBPS, this.persistBPS);
        EventEmitter.on(Events.sessionExpired, this.sessionExpired);
        EventEmitter.on(Events.EnableSessionExpireNotification, this.EnableSessionExpireNotification);
        EventEmitter.on(Events.DisplayApiResponse, this.handleApiResponse);
        EventEmitter.on(Events.DisplayApiErrorResponse, this.handleApiErrorResponse);
        EventEmitter.on(Events.currentChatsCheckerOutPut, this.getChatsCount);
        EventEmitter.on(Events.PasswordChange, this.PasswordChange);
        EventEmitter.on(Events.endQCBreak, this.endQCBreak);
        EventEmitter.on(Events.monitoringPanelType, this.MonitoringPanelTypes);
        EventEmitter.on(Events.openNestedWindow, this.openNestedWindow);
        EventEmitter.on(Events.LogoutAfterBreakApplied, this.LogoutAfterBreakApplied);
        EventEmitter.on(Events.displaySurveyButtonRequest, this.displaySurveyButton);
        EventEmitter.on(Events.route2ndSurvey, this.route2ndSurvey);
        EventEmitter.on(Events.internetConnectivityNotify, this.internetConnectivityNotify);
        EventEmitter.on(Events.BreakApplied, this.forceFullyApplyBreak);
        EventEmitter.on(Events.resetSignalRConnectionChecker, this.resetSignalRConnectionChecker);
        EventEmitter.on(Events.reLogin, this.reLogin);
        EventEmitter.on(Events.PopUpPermission, this.PopUpPermission);

    }

    loadUnsentChats = async () => {
        if (utils.isElectronBuild()) {
            window?.myAPI?.loadUnsentChats("loadUnsentChats", async (data) => {
                await utils.GetUnsentChats()
            });
        }
    }

    startRingtone = () => {
        if (this.audioRef.current) {
            this.audioRef.current.play();
            this.setState({ isPlaying: true });
        }
    };

    stopRingtone = () => {
        if (this.audioRef.current) {
            this.audioRef.current.pause();
            this.audioRef.current.currentTime = 0; // Reset to the beginning
            this.setState({ isPlaying: false });
        }
    };

    PopUpPermission = () => {
        this.setState({ showPopUpPermissionModal: true })
    }


    preventCall = (data: boolean) => {
        if (data) {
            this.toast?.show({
                severity: t("toast.info"),
                summary: "Video Call Response",
                detail: "You're already in a call. Please end it before starting a new one.",
                contentClassName: "",
            });
        }
    }


    reLogin = async () => {
        let isIpChanged = false;

        if (utils.isLiveAdminsCompany(this.state.userData?.userLoginData.empCompId) && utils.isElectronBuild()) {

            const latestIP = await wglcsApiService.getIpAddress();
            const previousIP = LocalStorageService.getLocalStorage("loginTimeApi");

            if (latestIP && previousIP && latestIP !== previousIP) {
                isIpChanged = true;

                const userName = this.state.userData?.userLoginData.username;
                const password = this.state.userData?.userLoginData.userPassword;
                const appName = this.getAppName();

                const loginResult = await loginService.login(userName, password, '01-05-03-01', latestIP, appName);

                if (loginResult.success) {
                    LocalStorageService.setLocalStorage("loginTimeApi", latestIP);
                    wglcsApiService.setAuth(loginResult.data?.accessToken?.auth_token)
                    this.handleLoginSuccess(loginResult.data);
                } else {
                    console.log("Case 4: Re-login failed");
                }
            }
        }
    };

    getExpiredCanned = async () => {
        if (
            utils.isLiveAdminsCompany(this.state.userData.userLoginData.empCompId) &&
            this.state.userData?.interfaces?.some((x) => x.interfaceName === "Expired Canned Alerts")
        ) {
            let response: any = await wglcsApiService.gettodayexpiredcanned();
            if (response?.data?.data?.length > 0) {
                response?.data?.data?.forEach((element) => {
                    notificationService.showNotification("", element.websiteTitle + " has expired canned.Please modify or delete accordingly.");
                });
            }
        }
    }

    // Get application name and version info
    getAppName = () => {
        let appName = utils.isElectronBuild() ? "React Electron : " : "React Web : ";
        appName += `version : ${process.env.REACT_APP_VERSION} :`;

        if (browser) {
            appName += `${browser.name} ${browser.version} : ${browser.os}`;
        }

        return appName;
    };
    // Handle successful login and save data to localStorage
    handleLoginSuccess = (loginData) => {
        const customizedInterfaces = this.customizeInterfaces(loginData?.interfaces);
        if (customizedInterfaces) {
            loginData.interfaces = customizedInterfaces;
        }

        this.setState({ userData: loginData })
        localStorage.setItem("USER_DATA", JSON.stringify(loginData));
        EventEmitter.emit(Events.refreshUserData, "")

    };
    customizeInterfaces = (interfaces: RoleInterface[]) => {
        if (utils.isMonitoringPanelAllowed(interfaces)) {
            interfaces.push({ interfaceId: 0, interfaceName: "Monitoring Panel" });
        }

        if (utils.isHybridPanelAllowed(interfaces)) {
            interfaces.push({ interfaceId: 0, interfaceName: "Hybrid Panel" });
        }

        if (utils.isQuickResponses(interfaces)) {
            interfaces.push({ interfaceId: 0, interfaceName: "Quick Responses" });
        }

        let _interfaces = this.getReportModulePermission(interfaces);
        return _interfaces;
    };

    getReportModulePermission = (interfaces) => {
        var isAllowed = false;
        const flattenedSubArrays = reportsScreenSubRoutes()?.flatMap((item) => item.subArray);
        flattenedSubArrays?.forEach((element) => {
            if (interfaces?.some((x) => x.interfaceName?.toLowerCase() == element.interfaceName?.toLowerCase())) {
                isAllowed = true;
            }
        });

        if (!isAllowed) {
            let filtered = interfaces?.filter((c) => c.interfaceName != "Dashboard Reports");
            return filtered;
        }

        return interfaces;
    };

    videoStatus = (msg: string) => {
        if (msg == "calling") {
            this.setState({ videoAlert: true, videoAlertMsg: "Calling...", videoAlertSeverty: "v-warning" });
            this.callResponseTimer()
            this.clearHideCallAlertInterval()
            this.startRingtone()
        } else if (msg == "accepted") {
            this.setState({ videoAlert: true, videoAlertMsg: "Call Accepted", videoAlertSeverty: "v-success" });
            this.stopRingtone()
            this.clearEndTimerInverval()
            this.clearHideCallAlertInterval()
        } else if (msg == "declined") {
            this.setState({ videoAlert: true, videoAlertMsg: "Call Declined", videoAlertSeverty: "v-danger" });
            this.stopRingtone()
            this.clearEndTimerInverval()
            this.resetVideoStatus()
        } else if (msg == "started") {
            this.setState({ videoAlert: true, videoAlertMsg: "Call in Progress", videoAlertSeverty: "v-success" });
            this.clearEndTimerInverval()
            this.clearHideCallAlertInterval()
            this.startCallTime()
        } else if (msg == "not-responding") {
            this.setState({ videoAlert: true, videoAlertMsg: "Visitor not Responding", videoAlertSeverty: "v-danger" });
            this.stopRingtone()
            this.clearEndTimerInverval()
            this.resetVideoStatus()
            EventEmitter.emit(Events.videoCallPing, "not-responding")
        } else if (msg == "ended") {
            this.setState({ videoAlert: false, videoAlertMsg: "" });
            this.stopRingtone()
            this.endCallTime()
            this.resetVideoStatus()
        } else {
            this.setState({ videoAlert: false, videoAlertMsg: "" });
        }
    }

    startCallTime = () => {
        const videoStartTime = new Date() as any;
        this.setState({ videoStartTime, elapsedTime: 0, callStarted: true }, () => {
            const interval = setInterval(() => {
                const elapsedTime = Math.floor((new Date() as any - videoStartTime) / 1000);
                this.setState({ elapsedTime });
            }, 1000);
            this.setState({ timerInterval: interval });
        });
    }

    endCallTime = () => {
        const videoEndTime = new Date();
        this.setState({ callStarted: false, videoEndTime });

        if (this.state.videoStartTime && this.state.videoEndTime && this.state.elapsedTime) {
            const obj = {
                startTime: this.state.videoStartTime.toLocaleTimeString(),
                endTime: this.state.videoEndTime.toLocaleTimeString(),
                duration: this.formatTime(this.state.elapsedTime)
            }
            EventEmitter.emit(Events.videoCallEndedInfo, obj);
        }

        clearInterval(this.state.timerInterval);
    }

    formatTime(seconds) {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    }

    resetVideoStatus = () => {
        const hideInterval = setTimeout(() => {
            this.setState({ videoAlert: false, videoAlertMsg: "" });
        }, 10000)
        this.setState({ hideCallAlertInterval: hideInterval })
    }

    clearHideCallAlertInterval = () => {
        clearInterval(this.state.hideCallAlertInterval)
    }

    callResponseTimer = () => {
        const videoDetails = window.localStorage.getItem("videoDetails");
        let chatId = null;

        if (videoDetails) {
            try {
                const obj = JSON.parse(videoDetails);
                chatId = obj.sessionName;
            } catch (error) {
                console.error("Error parsing call details:", error);
            }
        }

        const interval = setInterval(() => {
            this.setState((prevState) => {
                if (prevState.callEndTimer >= 30) {
                    if (chatId) {
                        EventEmitter.emit(Events.removeVideoCallInfo, chatId);
                    }

                    clearInterval(interval);
                    EventEmitter.emit(Events.videoStatus, "not-responding");
                    EventEmitter.emit(Events.clearVideoDetails);
                    return { callEndTimer: 0 };
                }
                return { callEndTimer: prevState.callEndTimer + 1 };
            });
        }, 1000);

        this.setState({ timerInterval: interval });
    }

    clearEndTimerInverval = () => {
        clearInterval(this.state.timerInterval);
        this.setState({ callEndTimer: null })
    }

    resetSignalRConnectionChecker = () => {
        this.checkSignalRConnectionCount = 0;
    }
    surveyCountNotify = () => {
        const unSentChatBroadCast = new BroadcastChannel("survey_count_notify")
        unSentChatBroadCast.onmessage = (event: any) => {
            if (event.data === "survey_count_notify") {
                let count = cookieService.getElectronCookies("RoutedSurveyCount");
                this.setState({ surveyChatCount: count as any })
            }
        };
    }

    unSentChatNotify = () => {
        // const unSentChatBroadCast = new BroadcastChannel("unsent_chat_modify")
        // unSentChatBroadCast.onmessage = (event: any) => {
        //     if (event.data === "unsent_chat_modify") {
        //         this.timerId = setTimeout(() => {
        //             const unSentChatsCount = window.localStorage.getItem("unsentchat")
        //             if (unSentChatsCount) {
        //                 this.setState({ unSentChatsCount: unSentChatsCount as any })
        //             }
        //         }, 2000)
        //     }
        // };
    }

    internetConnectivityNotify = () => {
        const internetStatus = window.localStorage.getItem("internetConnectivity")
        if (internetStatus) {
            this.setState({ internetConnectivity: internetStatus as any })
        }
    }

    sendSurveyBroadcast = () => {
        const unSentChatBroadCast = new BroadcastChannel("survey_count_notify")
        unSentChatBroadCast.postMessage("survey_count_notify")
    }

    openNestedWindow = async (url) => {
        if (url != undefined && url != null && url != "") {
            var flag = await utils.isElectronBuild();
            if (!flag) {
                window.open(url);
            } else {
                window.myAPI.OpenVisitorLink(url);
            }
        }
    };

    MonitoringPanelTypes = (type) => {
        if (type == MonitoringPanelTypes.UserWise) {
            this.setState({ MonitoringPanelType: " User Wise" });
        } else {
            this.setState({ MonitoringPanelType: " Website Wise" });
        }
    };

    toggleCustomizer = () => {
        EventEmitter.emit(Events.toggleCustomizer);
    };

    PasswordChange = (message) => {
        this.setState({ responseMessage: message, severity: "success" });
        this.setState({ openSnackBar: true });
    };

    displaySurveyButton = (isDisplay) => {
        this.setState({ showPendingSurvey: isDisplay });
    };

    internetConnectionChange = () => {
        if ('connection' in navigator) {
            const connection = navigator.connection as any;

            const handleNetworkChange = () => {
                const netInfo = `netInfo: network type: ${connection.effectiveType}, downlink speed: ${connection.downlink} mbps `
                this.detectIsIPChanged(netInfo)
            };

            connection.addEventListener('change', handleNetworkChange);
        } else {
            console.log("The Network Information API is not supported in this browser.");
        }
    }

    changeInternet = async (e) => {
        if (e.type == "online") {
            setTimeout(() => {
                this.detectIsIPChanged()
            }, 5000);
        }
    }

    detectIsIPChanged = async (netInfo: string = "") => {
        const ip = LocalStorageService.getLocalStorage("loginTimeApi");
        if (ip != null && ip != undefined && ip != "") {
            const latestIp = await wglcsApiService.getIpAddress();
            if (latestIp != ip) {
                const userData = userService.GetUserData();
                const values = `newIp:${latestIp}, previousIp:${ip}, ${netInfo}reason:Ip changed, dateTime: ${moment().format("h:mm:ss DD/MM/YYYY")}`
                if (latestIp !== "0.0.0.0") {
                    LocalStorageService.setLocalStorage("loginTimeApi", latestIp);
                }
                wgLogs.rolePermissionLogs(wgLogType.Insert, wgModules.reLogin, userData?.userLoginData?.userId?.toString()!, values)
            }
        }
    }

    componentDidMount = async () => {
        if (utils.isElectronBuild()) {
            window.myAPI?.setLoggedInUserData(userService.GetUserData()?.userLoginData);
        }

        this.internetConnectionChange()

        window.addEventListener("online", (e) => this.changeInternet(e));

        // if ((navigator as any)?.connection) {
        //     const connection = (navigator as any)?.connection;
        //     connection.addEventListener('change', () => {
        //     });
        // }

        var breakStatus = localStorage.getItem("breakStatus");
        if (breakStatus != null && breakStatus != undefined && utils.getCurrentPathName() == monitoringPanelLink) {
            if (parseInt(breakStatus) == BreakStatus.Apply) {
                this.setState({ breakStatus: BreakStatus.Apply, isOperatorOnBreak: true, BreakTitle: "end Break" });
                this.breakInterval = setInterval(this.markedBreak, 1 * 1000);
            } else if (parseInt(breakStatus) == BreakStatus.Start) {
                this.setState({
                    breakStatus: BreakStatus.Start,
                    isOperatorOnBreak: true,
                    BreakTitle: "end Break",
                    endBreakTitle: t("Logged In Resources.On Break"),
                });
            }
        }

        const isFunctionCalled = localStorage.getItem("getExpiredCannedCalled");
        if (!isFunctionCalled) {
            this.getExpiredCanned();
            localStorage.setItem("getExpiredCannedCalled", "true");
        }

        this.route2ndSurvey();
        // this.unSentChat();
        // this.sendSurveyBroadcast();
        this.strophConnectionStatus();
        this.signalRConnectionStatus();

        this.IsLogIDAliveInterval = setInterval(this.IsLogIDAlive, 15000);
        if (!utils.isElectronBuild() && !window.location.origin?.includes("localhost")) {
            this.newUpdateInterval = setInterval(this.cacheBusterInterval, 600000);
        }

        // if (
        //     utils.isLiveAdminsCompany(this.state.userData?.userLoginData?.empCompId) &&
        //     utils.isOpertorPanelAllowed(this.state.userData?.interfaces)
        // ) {
        //     // this.unSentChatInterval = setInterval(this.unSentChat, 300000);
        // }

        var path = utils.getCurrentPathName();
        this.setState({ currentPath: path });

        var _break = JSON.parse(localStorage.getItem("OnBreakUsers") as any);
        if (_break !== undefined && utils.getCurrentPathName() == OperatorPanelRoute) {
            if (_break?.some((x) => x.userId?.toString() === this.state.userData?.userLoginData?.userId?.toString())) {
                this.setState({ isOperatorOnBreak: true });
            }
        }

        window.addEventListener("storage", (e) => {
            let duplicateTabStr = localStorage.getItem("duplicateTab") || null;
            let redirectTabStr = localStorage.getItem("redirectTab") || null;

            if (duplicateTabStr !== null) {
                if (redirectTabStr !== null && (utils.getCurrentPathName() === "/chat/:chatid" || utils.getCurrentPathName() === "/hybridChat")) {
                    localStorage.removeItem("duplicateTab");
                    localStorage.removeItem("redirectTab");
                    window.open("/dashboard", "_self");
                }
            }

            this.strophConnectionStatus();
            this.signalRConnectionStatus();
            var userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;
            if (userData == null || userData == undefined) {
                if (utils.isElectronBuild()) {
                    var log = `[${moment().format("h:mm:ss DD/MM/YYYY")}] ---- method:Listener: getting user data is null -----User Name : ${this.state.userData?.userLoginData?.username
                        }`;
                    window.myAPI.LogoutLog(log);
                }
                loginService.logout("LogId is Not Alive.");
            }
        });
    };

    cacheBusterInterval = () => {
        this.cacheBuster()
    }

    cacheBuster = () => {
        fetch(process.env.PUBLIC_URL + "/version.json", { cache: "no-store" })
            .then((response) => response.json())
            .then((data) => {
                let preVersion = LocalStorageService.getLocalStorage("APP_VERSION");
                if (data?.version != null && data?.version != undefined && preVersion != data?.version) {
                    LocalStorageService.setLocalStorage("APP_VERSION", data?.version);
                    this.setState({ showUpdateModal: true });
                }
            })
            .catch((error) => {
                console.log("error in version fetching" + error)
            });
    };

    getChatsCount = (chatsCount) => {
        localStorage.setItem("runningChatsCount", chatsCount)
        this.setState({ runningChatsCount: parseInt(chatsCount) });
    };

    handleApiResponse = (message) => {
        this.setState({ responseMessage: message, severity: "success" });
        this.setState({ openSnackBar: true });
    };

    handleApiErrorResponse = (message) => {
        this.setState({ responseMessage: message, severity: "error" });
        this.setState({ openSnackBar: true });
    };

    strophConnectionStatus = () => {
        var status = sessionStorageService.getItem("OpenFireConnectionStatus");

        if (status == "CONNECTING") {
            this.setState({ connectionStatus: ConnectionStatus.Connecting });
        } else if (status == "Connected") {
            this.setState({ connectionStatus: ConnectionStatus.Connected });
        } else if (status == "DISCONNECTED") {
            this.setState({ connectionStatus: ConnectionStatus.Disconnected });
        }
    };

    componentDidUpdate(prevProps: NavigationBarProps, prevState: NavigationBarState) {
        var path = utils.getCurrentPathName();
        if (path != "" && path != this.state.currentPath) {
            this.props.toggleSidebarMenu(false);
            this.setState({ currentPath: path, toggle: false });
        }
    }

    forceFullyApplyBreak = () => {
        if (this.checkUserOnBreak()) {
            this.setState({ isOperatorOnBreak: false })
        } else {
            this.setState({ isOperatorOnBreak: true })
        }
    };

    EnableSessionExpireNotification = (flag) => {
        if (!flag) {
            this.setState({ IsSessionExpireNotificationEnabled: false });
            clearInterval(this.sessionExpireInterval);
            return;
        }

        if (flag && !this.state.IsSessionExpireNotificationEnabled) {
            this.setState({ IsSessionExpireNotificationEnabled: true });
            this.sessionExpireInterval = setInterval(this.SessionExpireNotification, 300000);
        }
    };

    SessionExpireNotification = () => {
        notificationService.showNotification("", ResponseMessage.expireSessionWarnningMessage);
    };

    // checkLatestUpdate = () => {
    //     fetch(process.env.PUBLIC_URL + "/version.json")
    //         .then((response) => response.json())
    //         .then((data) => {
    //             let preVersion = LocalStorageService.getLocalStorage("APP_VERSION");
    //             if (preVersion != data?.latest_Version) {
    //                 LocalStorageService.setLocalStorage("APP_VERSION", data?.latest_Version);
    //                 this.setState({ showUpdateModal: true });
    //             }
    //         })
    //         .catch((error) => { });
    // };

    signalRConnectionStatus = () => {
        var status = sessionStorageService.getItem("SignalRConnectionStatus");

        if (status?.toLowerCase() == "connecting") {
            this.setState({ SignalRconnectionStatus: ConnectionStatus.Connecting });
        } else if (status?.toLowerCase() == "connected") {
            this.setState({ SignalRconnectionStatus: ConnectionStatus.Connected });
        } else if (status?.toLowerCase() == "disconnected") {
            this.setState({ SignalRconnectionStatus: ConnectionStatus.Disconnected });
        }
    };

    sessionExpired = () => {
        this.setState({ sessionExpiredAlert: true });
    };

    logOutOnSessionExpired = () => {
        // EventEmitter.emit(Events.onLogOut, "");
        this.setState({ sessionExpiredAlert: false });
        window.location.reload()
    };

    diff_hours = (dt2, dt1) => {
        var diff = (dt2.getTime() - dt1.getTime()) / 1000;
        diff /= 60 * 60;
        return Math.abs(Math.round(diff));
    };

    ForceFullyLogout = () => {
        var loggedIntime = localStorage.getItem("loggedinTime");
        // if (loggedIntime == null || loggedIntime == undefined) {
        //     EventEmitter.emit(Events.onLogOut);
        // }

        if (loggedIntime != null && loggedIntime != undefined) {
            var myDate_ = new Date(loggedIntime);
            var difference = this.diff_hours(myDate_, new Date());
            if (difference > 12) {
                if (utils.isElectronBuild()) {
                    var log = `[${moment().format("h:mm:ss DD/MM/YYYY")}] ---- method:ForceFullyLogout in navigation -----User Name : ${this.state.userData?.userLoginData?.username
                        }`;
                    window.myAPI.LogoutLog(log);
                }

                const values = `newIp:0, previousIp:0,reason:logout after 12 hours `
                wgLogs.rolePermissionLogs(wgLogType.Insert, wgModules.reLogin, this.state.userData?.userLoginData.userId?.toString(), values)

                EventEmitter.emit(Events.onLogOut);
            }
        }
    };

    saveChangedCannedMsg = async () => {
        if (this.BPSMessages?.length > 0) {
            let response = await wglcsApiService.save_changedcannedmsg(this.BPSMessages);
            this.BPSMessages = [];
        }
    };



    IsLogIDAlivePermission = () => {
        var res = localStorage.getItem("IsLogIDAliveTime")
        if (res != undefined && res != null && res != "") {
            let difference = utils.getTimeDifference(moment(res), new Date())
            if (difference > 13) {
                return true
            }
            return false
        }

        return true
    }

    IsLogIDAlive = async () => {
        if (utils.isAnyChatPanelActive() && this.checkSignalRConnectionCount < 6) {
            signalRChatService.getUserIdOrConnId()
            this.checkSignalRConnectionCount += 1
        }

        this.saveChangedCannedMsg();
        this.ForceFullyLogout();

        var logIdResult: any = null

        if (this.IsLogIDAlivePermission() && !utils.isOperaterScreenActive()) {
            localStorage.setItem("IsLogIDAliveTime", new Date()?.toString())
            logIdResult = await wglcsApiService.getIsLogIDAlive(this.state.userData?.userLoginData.userLog);
        }

        if (logIdResult?.message == "Network Error") {
            this.setState({ internetConnectionStatusMessage: "Connecting..., Please wait" });
            await chatService.disconnect();
            sessionStorageService.setItem("OpenFireConnectionStatus", "DISCONNECTED");
            sessionStorageService.setItem("SignalRConnectionStatus", "DISCONNECTED");
            this.strophConnectionStatus();
            this.signalRConnectionStatus();
        } else {
            this.setState({ internetConnectionStatusMessage: "" });
        }

        // if (logIdResult != null && logIdResult != undefined && logIdResult?.errors?.length > 0) {
        //     if (utils.tokenExpire(logIdResult?.errors[0]?.Code)) {
        //         if (utils.isElectronBuild()) {
        //             var log = `[${moment().format("h:mm:ss DD/MM/YYYY")}] ---- method: IsLogIDAlive in navigation -----User Name : ${this.state.userData?.userLoginData?.username
        //                 }`;
        //             window.myAPI.LogoutLog(log);
        //         }
        //         return;
        //     }
        // }

        if (logIdResult?.data != null && logIdResult?.success && logIdResult.message != "Network Error") {
            if (logIdResult?.data as any == false) {

                const values = `newIp:0, previousIp:0,reason: Logout because loggedIn on another location `
                wgLogs.rolePermissionLogs(wgLogType.Insert, wgModules.reLogin, this.state.userData?.userLoginData.userId?.toString(), values)


                var isAlreadyLogout = localStorage.getItem("logOut");
                if (isAlreadyLogout == null || isAlreadyLogout == undefined) {
                    notificationService.showNotification("", t("toast.signedOutMessage"), true);
                    localStorage.setItem("logOut", "logout");
                }

                if (utils.isElectronBuild()) {
                    var log = `[${moment().format("h:mm:ss DD/MM/YYYY")}] ---- method:LogId is Not Alive.  -----User Name : ${this.state.userData?.userLoginData?.username
                        }`;
                    window.myAPI.LogoutLog(log);
                }
                loginService.logout("LogId is Not Alive.");
            }
        }

        if (logIdResult?.data == null && logIdResult?.success == false && logIdResult.errors == null && logIdResult.message == "Request failed with status code 401") {

            var isAlreadyLogout = localStorage.getItem("logOut");
            if (isAlreadyLogout == null || isAlreadyLogout == undefined) {
                notificationService.showNotification("", t('toast.signedOutMessage'), true);
                localStorage.setItem("logOut", "logout");
            }

            const values = `newIp:0, previousIp:0,reason: Logout because loggedIn on another location `
            wgLogs.rolePermissionLogs(wgLogType.Insert, wgModules.reLogin, this.state.userData?.userLoginData.userId?.toString(), values)

            if (utils.isElectronBuild()) {
                var log = `[${moment().format("h:mm:ss DD/MM/YYYY")}] ---- method:LogId is Not Alive.  -----User Name : ${this.state.userData?.userLoginData?.username
                    }`;
                window.myAPI.LogoutLog(log);
            }
            loginService.logout("LogId is Not Alive.");

        }

        if (!xmppChatService.isStropheConnected() && (this.state.currentPath == "/chat/:chatid" || this.state.currentPath == "/hybridChat")) {
            notificationService.showNotification("", ResponseMessage.reConnectingMessage);
        }

        if (utils.isLoggedInResourcesScreenActive()) {
            let result = await wglcsApiService.getLoggedInResponses(this.state.userData?.userLoginData?.empCompId);
            var res = result?.data?.data;
            this.userWentAway(res);
            this.removeWentAwayUsers(res);
        }


        // if (utils.isLiveAdminsCompany(this.state.userData.userLoginData.empCompId) && utils.isOperaterScreenActive()) {
        //     var userId = this.state.userData?.userLoginData?.userId;
        //     var response = await wglcsApiService.getunsentchats(userId) as any;
        //     if (response?.success) {
        //         localStorage.setItem("unsentchat", (response?.data as any)?.length);
        //         this.setState({ unSentChats: response?.data as any, unSentChatsCount: (response?.data as any)?.length });
        //         const unSentChatBroadCast = new BroadcastChannel("unsent_chat_modify") as any;
        //         unSentChatBroadCast.postMessage("unsent_chat_modify")
        //     }
        // }
    };

    persistBPS = (newRow) => {
        this.BPSMessages.push(newRow);
    };

    unSentChat = async () => {
        // this.GetUnsentChats();

        // var text = "";
        // if (this.state.unSentChats?.length > 0) {
        //     if (this.state.unSentChats?.length === 1) {
        //         text = ResponseMessage.unSentChatSingle(this.state.unSentChats?.length);
        //     } else {
        //         text = ResponseMessage.unSentChatMultiple(this.state.unSentChats?.length);
        //     }
        //     notificationService.showNotification("", text);
        // }
    };

    async componentWillUnmount() {
        clearInterval(this.IsLogIDAliveInterval);
        // clearInterval(this.unSentChatInterval);
        clearTimeout(this.timerId);
    }

    // onStropheStatusChanged = (status: ConnectionStatus) => {
    //     this.setState({ connectionStatus: status });
    // };

    handleClick = () => {
        // this.setState({ toggle: !this.state.toggle });
        this.setState({ toggle: true });
        this.props.maskLayout(true);
        this.props.toggleSidebarMenu(true);
        // this.props.toggleSidebarMenu(!this.state.toggle);

    };

    endQCBreak = () => {
        clearInterval(this.breakInterval);
        this.setState({ breakStatus: BreakStatus.End, endBreakTitle: "", isOperatorOnBreak: false });
        LocalStorageService.setLocalStorage("breakStatus", BreakStatus.End);
        this.updateUserBreakLogs("BreakEndTime");
        EventEmitter.emit(Events.monitoringPanelBreakStatus, BreakStatus.End);
        notificationService.showNotification("", t("notificationMessages.breakEnd"));
    };

    updateUserBreakLogs = async (updateColumn) => {
        const body = {
            logId: this.state.userData?.userLoginData?.userLog,
            breakId: this.breakId,
            userId: this.state.userData?.userLoginData?.userId,
            breakApproved: false,
            approvedBy: "",
            updateColumn: updateColumn,
        };
        const response = await wglcsApiService.updateuserbreaklogs(body);
    };

    saveUserBreakLogs = async () => {
        const body = {
            logId: this.state.userData?.userLoginData?.userLog,
            userId: this.state.userData?.userLoginData?.userId,
            breakTypeId: 3,
            breakRequest: true,
            interface: "Monitoring Panel",
        };
        const response = await wglcsApiService.saveuserbreaklogs(body);
        if (response?.data?.data != null) {
            this.breakId = response?.data?.data?.breakId;
        }

        notificationService.showNotification("", t("notificationMessages.closeNotification"));
    };

    markedBreak = () => {
        if (this.state.runningChatsCount == 0 || this.state.runningChatsCount == null || this.state.runningChatsCount == undefined) {
            EventEmitter.emit(Events.monitoringPanelBreakStatus, BreakStatus.Start);
            clearInterval(this.breakInterval);
            LocalStorageService.setLocalStorage("breakStatus", BreakStatus.Start);
            this.setState({ breakStatus: BreakStatus.Start, endBreakTitle: t("Logged In Resources.On Break") });
            this.updateUserBreakLogs("BreakTypeId");
            notificationService.showNotification("", t("notificationMessages.leaveBreak"));
        } else {
            EventEmitter.emit(Events.currentChatsChecker, "");
        }
    };

    changeBreakStatus = () => {
        if (utils.getCurrentPathName() == monitoringPanelLink) {
            if (!this.state.isOperatorOnBreak) {
                EventEmitter.emit(Events.monitoringPanelBreakStatus, BreakStatus.Apply);
                EventEmitter.emit(Events.currentChatsChecker, "");
                this.setState({ breakStatus: BreakStatus.Apply });
                LocalStorageService.setLocalStorage("breakStatus", BreakStatus.Apply);
                this.saveUserBreakLogs();
                setTimeout(() => {
                    this.breakInterval = setInterval(this.markedBreak, 1 * 1000);
                }, 2000);
            } else if (this.state.isOperatorOnBreak && this.state.breakStatus == BreakStatus.Apply) {
                clearInterval(this.breakInterval);
                EventEmitter.emit(Events.monitoringPanelBreakStatus, BreakStatus.End);
                LocalStorageService.setLocalStorage("breakStatus", BreakStatus.Cancel);
                this.setState({ breakStatus: BreakStatus.Cancel, endBreakTitle: "" });
                this.updateUserBreakLogs("BreakCancelTime");
                notificationService.showNotification("", t("notificationMessages.breakEnd"));
            } else {
                clearInterval(this.breakInterval);
                this.setState({ breakStatus: BreakStatus.End, endBreakTitle: "" });
                LocalStorageService.setLocalStorage("breakStatus", BreakStatus.End);
                this.updateUserBreakLogs("BreakEndTime");
                EventEmitter.emit(Events.monitoringPanelBreakStatus, BreakStatus.End);
                notificationService.showNotification("", t("notificationMessages.breakEnd"));
            }
        } else {
            if (this.state.isOperatorOnBreak) {
                EventEmitter.emit(Events.endOperatorBreak, null!);
            } else {
                this.toast?.show({
                    severity: t("toast.info"),
                    summary: t("toast.Break response"),
                    detail: t("toast.checkUserOnBreakdetail"),
                    contentClassName: "",
                });
                EventEmitter.emit(Events.startOperatorBreak, null!);

            }
        }
        this.setState({ isOperatorOnBreak: !this.state.isOperatorOnBreak });
    };

    getHeading = () => {
        const content: ContentModel = ResponseMessage.getEenvironmentWiseContent();

        if (this.state.currentPath === "/dashboard") {
            return t("Dashboard");
        } else if (this.state.currentPath === "/chat/:chatid") {
            return t("Start Chatting.title");
        } else if (this.state.currentPath === "/hybridChat") {
            return content.hybridPanel;
        } else if (this.state.currentPath === "/transcript") {
            return content.ChatTranscript;
        } else if (this.state.currentPath === "/resourcesPool") {
            return t("Resource Pool.title");
        } else if (this.state.currentPath === "/resourcesPool/personal-information") {
            return t("Add Resource");
        } else if (this.state.currentPath === "/ip-block") {
            return t("IP Block.title");
        } else if (this.state.currentPath === "/canned") {
            return content.CannedResponses;
        } else if (this.state.currentPath === "/report") {
            return t("Reports.title");
        } else if (this.state.currentPath === "/pcanned") {
            return content.PersonalCanned;
        } else if (this.state.currentPath === "/push_content") {
            return content.PushContent;
        } else if (this.state.currentPath === "/logged-in-resources") {
            return t("Logged In Resources.title");
        } else if (this.state.currentPath === "/transcriptSubscribers") {
            return t("Transcripts Subscribers.title");
        } else if (this.state.currentPath === "/smtpEmail") {
            return t("Smtp Email Setup");
        } else if (this.state.currentPath === "/OneStepAccount") {
            return t("One Step Account.title");
        } else if (this.state.currentPath === "/service-schedule") {
            return t("Service Schedule.title");
        } else if (this.state.currentPath === "/monitoringPanel") {
            return content.MonitoringPanel + this.state.MonitoringPanelType;
        } else if (this.state.currentPath === "/company") {
            return t("Companies.title");
        } else if (this.state.currentPath === "/website-wise-resources") {
            return t("Website wise Resources.title");
        } else if (this.state.currentPath === "/resources/trained-on") {
            return t("Trained on");
        } else if (this.state.currentPath === "/resources/trained-on-assign") {
            // var getUserName = "Test User";

            return "Assign Website to User";
        } else if (this.state.currentPath === "/Assign-Users-to-Trainee") {
            return t("Assign Users to Trainee.title");
        } else if (this.state.currentPath === "/Agent-PCM") {
            return t("Agent's PCM.title");
        } else if (this.state.currentPath === "/Point-System") {
            return t("Points System.title");
        } else if (this.state.currentPath === "/Chat-Logs") {
            return t("Chat Logs.title");
        } else if (this.state.currentPath === "/WebsiteService-Status") {
            return t("Website Service Status.title");
        } else if (this.state.currentPath === "/PCMs-Approval") {
            return t("PCMs Approval.title");
        } else if (this.state.currentPath === "/wrong-link-exceptions") {
            return t("wronglinkexception.title");
        } else if (this.state.currentPath === "/license-info") {
            return t("License Information.title");
        } else if (this.state.currentPath === "/resourcesPool/trained-on") {
            return t("Resource Pool.title");
        } else if (this.state.currentPath === "/Roles-Permission") {
            return t("Roles and Permissions.title");
        } else if (this.state.currentPath === "/Company-Allowed-Interfaces") {
            return t("Company Allowed Interfaces.title");
        } else if (this.state.currentPath === "/employee-company") {
            return t("EmployeeCompany.heading");
        } else if (this.state.currentPath === "/Survey-Questions") {
            return t("Survey.header");
        } else if (this.state.currentPath === "/Offline-Email-Exception") {
            return t("OfflineEmailException.title");
        } else if (this.state.currentPath === "/Offline-Email") {
            return t("One Step Account.Offline Email");
        }
        else if (this.state.currentPath.includes("/Dashboard-Reports")) {
            return t("DashboardReports.title");
        }
        else if (this.state.currentPath === "/testing-module") {
            return "Testing Module";
        }
        else if (this.state.currentPath === "/custom-schedule") {
            return t("Custom_Schedule.title");
        } else if (this.state.currentPath === "/Agent-Time-Line") {
            return t("agentTimeLine.title");
        } else if (this.state.currentPath === "/Involve-Configurations") {
            return t("involveConfiguration.title");
        } else if (this.state.currentPath === "/Master-QC") {
            return t("Master-QC.title");
        }
        else if (this.state.currentPath === "/bot") {
            return "Bot Builder";
        } else if (this.state.currentPath === "/View-All-Resources") {
            return t("View-All-Resources.title");
        }

        else {
            return "";
        }
    };

    renderRefreshIcon = () => {
        var hasRouteInMap = this.routePaths.has(this.state.currentPath);
        var isAllowedToDisplay = this.routePaths.get(this.state.currentPath);

        if (!hasRouteInMap || isAllowedToDisplay) {
            return <RefereshApi />;
        }

        return "";
    };

    getTitle = () => {
        if (this.state.userData?.userLoginData?.empCompId === "01-1326") {
            return t("MainComponent.End On-Call");
        } else {
            return t("MainComponent.End Break");
        }
    };

    getBreakTitle = (title: string) => {
        var isOperatorOnBreak = title != "";
        this.setState({ isOperatorOnBreak: isOperatorOnBreak, endBreakTitle: title });
    };

    LogoutAfterBreakApplied = (value) => {
        if (this.state.onLogOutMode && value != "") {
            this.setState({ showLogoutModal: true });
        }
        this.setState({ onLogOutMode: false });
    };

    setWentAwayUsersLocalStorage(obj) {
        localStorage.setItem("wentAwayUsers", JSON.stringify(obj));
    }

    getWentAwayUsersLocalStorage(): WentAwayUsers[] | null {
        return JSON.parse(localStorage.getItem("wentAwayUsers")!) as WentAwayUsers[];
    }

    removeWentAwayUsers(obj: any) {
        var existingUsers = this.getWentAwayUsersLocalStorage() || [];

        existingUsers?.forEach((element) => {
            obj?.forEach((e) => {
                if (element.userId?.toString() === e.userId?.toString() && e.operatorStatus === 1) {
                    let filtered = existingUsers?.filter((x) => x.userId !== element.userId);
                    this.setWentAwayUsersLocalStorage(filtered);
                }
            });
        });
    }

    checkUserExists = (userId: number): boolean => {
        var existingUser = (this.getWentAwayUsersLocalStorage() as WentAwayUsers[]) || [];
        if (existingUser !== null && existingUser !== undefined && existingUser?.length > 0) {
            if (existingUser?.some((x) => x.userId === userId)) {
                return false;
            } else {
                return true;
            }
        } else {
            return true;
        }
    };

    userWentAway = (data) => {
        var existingUser = (this.getWentAwayUsersLocalStorage() as WentAwayUsers[]) || [];
        var newArray = [] as WentAwayUsers[];
        data?.forEach((element) => {
            if (element?.operatorStatus == 3 && element?.currentChats > 0 && this.checkUserExists(element.userId)) {
                notificationService.showNotification("", element?.userName + t("notificationMessages.went-away"));
                if (existingUser == null) {
                    newArray.push({ userId: element.userId });
                } else {
                    newArray = existingUser;
                    newArray.push({ userId: element.userId });
                }
                this.setWentAwayUsersLocalStorage(newArray);
            }
        });
    };

    // isGreetingActive = async () => {
    //     var data = JSON.parse(localStorage.getItem("USER_DATA")!);

    //     var outStandingGreetCount = (await wglcsApiService.getoutstandinggreetsbyuser(data?.userLoginData.userId)).data?.data ?? 0;
    //     if (outStandingGreetCount as any > 0) {
    //         this.setState({ responseMessage: "Please wait until outstanding greets are closed. You will be informed shortly.", severity: "info" })
    //         this.setState({ openSnackBar: true })
    //         return true
    //     }

    //     return false
    // }

    getPersistedSurveyQuestions(): SurveyQuestionsForUserModel[] {
        var res = JSON.parse(localStorage.getItem("surveyQuestions")!);
        if (res == null) {
            return [];
        }
        return res;
    }

    route2ndSurvey = () => {
        this.setState({ showPendingSurvey: false });

        let count = cookieService.getElectronCookies("RoutedSurveyCount");
        if (parseInt(count) > 0) {
            this.setState({ showPendingSurvey: true });
            this.setState({ surveyChatCount: count as any });
            return;
        } else {
            this.setState({ showPendingSurvey: false });
        }
    };

    onBeforeLogout = async () => {
        debugger
        let opAcitve = window.localStorage.getItem("opActive");

        if (opAcitve === null) {
            window.localStorage.setItem("opActive", "false")
            opAcitve = "false"
        }

        EventEmitter.emit(Events.currentChatsChecker, "");
        var notSentChats = await this.GetUnsentChats();
        var res = notSentChats?.filter((x) => x.chatOrigin != "Chat2SMS");
        if (res?.length > 0) {
            this.setState({ responseMessage: t("toast.onBeforeLogout"), severity: t("toast.error") });
            this.setState({ openSnackBar: true });
            return;
        }

        if (this.state.runningChatsCount > 0 && utils.getCurrentPathName() == "/chat/:chatid") {
            this.setState({ responseMessage: t("toast.runningChatsCount"), severity: t("toast.error") });
            this.setState({ openSnackBar: true });
            return;
        }

        let count = cookieService.getElectronCookies("RoutedSurveyCount");
        if (parseInt(count) > 0) {
            this.setState({ showSurveyQuestionsModal: true, showPendingSurvey: true });
            return;
        }

        // this.setState({ showLogoutModal: true });
        if (utils.getCurrentPathName() == "/chat/:chatid" || opAcitve === "true") {
            if (this.state.isOperatorOnBreak) {
                this.setState({ showLogoutModal: true });
            } else {
                this.setState({ onLogOutMode: true });
                EventEmitter.emit(Events.startOperatorBreak, null!);

                if (!this.checkUserOnBreak() && opAcitve === "true") {

                    this.toast?.show({
                        severity: t("toast.info"),
                        summary: t("toast.Break response"),
                        detail: t("toast.checkUserOnBreakdetail"),
                        life: 3000,
                    });

                    let broadcastChannelBreak = new BroadcastChannel("break_mark") as any;
                    broadcastChannelBreak.postMessage("break_mark");

                    // broadcastChannelBreak.onmessage = (event: any) => {
                    //     if (event.data === "chats_still_active") {
                    //         this.setState({ responseMessage: t("toast.runningChatsCount"), severity: t("toast.error") });
                    //         this.setState({ openSnackBar: true });
                    //     }
                    // };

                    let broadcastChannelBreakMarked = new BroadcastChannel("break_marked") as any;
                    broadcastChannelBreakMarked.onmessage = (event: any) => {
                        if (event.data === "break_marked") {
                            this.setState({ showLogoutModal: true });
                        }
                    };
                } else {
                    this.setState({ showLogoutModal: true });
                }
            }
        } else {
            this.setState({ showLogoutModal: true });
        }
        // let surveyQuestions = (await wglcsApiService.getSurveyQuestionsForUser(this.state.userData.userLoginData.userId)).data!.data;
        // if (surveyQuestions?.length > 0) {
        //     this.setState({ showSurveyQuestionsModal: true, showPendingSurvey: true });
        // }
    };

    checkUserOnBreak = () => {
        var _break = JSON.parse(localStorage.getItem("OnBreakUsers") as any);
        if (_break != undefined) {
            if (_break?.some((x) => x.userId == this.state.userData.userLoginData?.userId)) {
                return true;
            } else {
                return false;
            }
        }
    };

    onNewNotification = (data: string) => {
        var arr = data?.split("|");
        if (arr[0] == this.state.userData?.userLoginData?.empCompId) {
            notificationService.showNotification("", arr[1]);
        }
    };

    onInternetConnectionChange = (available: boolean) => {
        if (available) {
            this.setState({ internetConnectionStatusMessage: "" });
        } else {
            var text = t("errorMessage.connecting-errormessage");
            this.setState({ internetConnectionStatusMessage: text });
        }
    };

    GetUnsentChats = async () => {
        if (utils.isLiveAdminsCompany(this.state.userData.userLoginData.empCompId)) {
            var userId = this.state.userData?.userLoginData?.userId;
            var response = await wglcsApiService.getunsentchats(userId);
            localStorage.setItem("unsentchat", (response?.data as any)?.length);
            this.setState({ unSentChats: response?.data as any, unSentChatsCount: (response?.data as any)?.length });
            return response?.data as any;
        }
    };

    handleUnsentChat = async () => {
        // const unSentChats = await this.GetUnsentChats()
        // this.setState({ showUnSentChatModal: true, unSentChats: unSentChats });
        // this.setState({ showUnSentChatModal: true });
    };


    handleClose = () => {
        this.setState({ showUnSentChatModal: false });
        // this.GetUnsentChats();
    };

    getLoadedData = (value) => {
        // clearInterval(this.unSentChatInterval);
        localStorage.setItem("unsentchat", value?.length);
        // this.setState({ unSentChats: value });
        // this.unSentChatInterval = setInterval(this.unSentChat, 300000);
    };

    RenderPendingSurveyMenu = () => {
        // let count = cookieService.getElectronCookies("tabs");
        if (parseInt(this.state.surveyChatCount) > 0) {
            return (
                <span className="unsent-chat-count" style={{ marginRight: "5px" }} onClick={this.handlePendingSurvey}>
                    {t("Survey.Pending Surveys")}: {this.state.surveyChatCount}
                </span>
            );
        }
    };

    handlePendingSurvey = () => {
        EventEmitter.emit(Events.showPendingSurvey, "");
    };

    getNotificationText = (message: string) => {
        if (!utils.isThisMobileDevice()) {
            this.speechSynthesis.cancel();
            if (message == "") {
                this.setState({ notificationMessage: "" });
                cacheService.cacheSRV("", "VoiceNotification");
                return;
            }
            this.setState({ notificationMessage: message });
        }
    };

    renderUnsentChat = () => {
        if (this.state.unSentChatsCount > 0 && utils.isLiveAdminsCompany(this.state.userData?.userLoginData?.empCompId)) {
            return (
                <span className="unsent-chat-count" onClick={() => this.handleUnsentChat()}>
                    {t("Unsent Chats:")} {this.state.unSentChatsCount}
                </span>
            );
        }
    };

    renderInternetStatus = () => {
        if (this.state.internetConnectivity as any == "false") {
            return <span className="unsent-chat-count" id="internet-alert">
                Re-Connecting Please wait...
            </span>
        } else {
            return ""
        }
    };
    renderVideoCallStatus = () => {
        const { elapsedTime } = this.state;
        if ((this.state.videoAlert as any) === true) {
            return (
                <span className={`unsent-chat-count video-call-status ${this.state.videoAlertSeverty}`} id="video-alert" style={{ paddingRight: this.state.callStarted ? "32px" : "" }}>
                    <span className="call-icon mr-1"><FontAwesomeIcon icon={faPhone} title="Phone" /></span>
                    <span className="call-label">{this.state.videoAlertMsg}</span>
                    <span className="call-timer">{this.state.callStarted ? this.formatTime(elapsedTime) : null}</span>
                </span>
            );
        } else {
            return "";
        }
    };

    disconnect = () => {
        signalRChatService.disconnect();
    };

    clearCache = () => {
        EventEmitter.emit(Events.setLoader, "")
        this.refreshCacheAndReload()
    }

    clearCacheAndReload = async () => {
        try {
            // Unregister all service workers
            if ('serviceWorker' in navigator) {
                const registrations = await navigator?.serviceWorker?.getRegistrations();
                for (const registration of registrations) {
                    await registration?.unregister();
                    console.log("Service worker unregistered.");
                }
            }

            if (window?.caches) {

                // Clear browser cache
                if (window?.caches) {
                    const { caches } = window;
                    const cacheNames = await caches.keys();
                    const cacheDeletionPromises = cacheNames.map((name) => caches.delete(name));
                    await Promise.all(cacheDeletionPromises);
                    console.log("Browser cache cleared.");
                }

                // Clear local storage
                localStorage.clear();
                console.log("Local storage cleared.");

                // Clear session storage
                sessionStorage.clear();
                console.log("Session storage cleared.");

                // Clear cookies
                document.cookie.split(";").forEach((cookie) => {
                    const eqPos = cookie.indexOf("=");
                    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
                });

                // Remove all <link> elements in the <head>
                const headElement = document.querySelector("head");
                const existingLinks = headElement?.querySelectorAll("link[rel='stylesheet']");
                existingLinks?.forEach((link) => link.remove());
                console.log("Removed all existing stylesheets.");

                // Remove all <script> elements
                const existingScripts = document.querySelectorAll("script[src]");
                existingScripts.forEach((script) => script.remove());
                console.log("Removed all existing scripts.");

                // Force reload the page
                // @ts-ignore: Firefox still has a `forceReload` parameter.
                window.location.reload(true);
                console.log("Page reloaded.");
            }
        } catch (error) {
            console.error("Error while clearing storage and reloading the page:", error);
        }

    };


    refresh = () => {
        EventEmitter.emit(Events.setLoader, "")
        this.setState({ showUpdateModal: false });
        this.refreshCacheAndReload()
    };

    refreshCacheAndReload = async () => {
        try {
            // Unregister all service workers
            if ('serviceWorker' in navigator) {
                const registrations = await navigator?.serviceWorker?.getRegistrations();
                for (const registration of registrations) {
                    await registration?.unregister();
                    console.log("Service worker unregistered.");
                }
            }

            if (window?.caches) {

                // Clear browser cache
                if (window?.caches) {
                    const { caches } = window;
                    const cacheNames = await caches.keys();
                    const cacheDeletionPromises = cacheNames.map((name) => caches.delete(name));
                    await Promise.all(cacheDeletionPromises);
                    console.log("Browser cache cleared.");
                }

                // Clear local storage
                localStorage.clear();
                console.log("Local storage cleared.");

                // Clear session storage
                sessionStorage.clear();
                console.log("Session storage cleared.");

                // Clear cookies
                document.cookie.split(";").forEach((cookie) => {
                    const eqPos = cookie.indexOf("=");
                    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
                });

                let version = LocalStorageService.getLocalStorage("APP_VERSION");


                // Clear all stylesheets
                const links = document.querySelectorAll("link[rel='stylesheet']");
                links?.forEach((link) => {
                    const htmlLink = link as HTMLLinkElement;
                    const newHref = `${htmlLink?.href?.split("?")[0]}?v=${version}`;
                    htmlLink.href = newHref;
                });

                // Clear all js files
                const scripts = document.querySelectorAll("script[src]");
                scripts?.forEach((script: any) => {
                    const htmlScript = script as HTMLScriptElement;
                    const newSrc = `${htmlScript?.src?.split("?")[0]}?v=${version}`;
                    const newScript = document?.createElement("script");
                    newScript.src = newSrc;
                    script?.parentNode?.replaceChild(newScript, script);
                    console.log(`Refreshed script: ${newSrc}`);
                });

                // Clear all images
                const images = document.querySelectorAll("img[src]");
                images?.forEach((image) => {
                    const htmlImage = image as HTMLImageElement;
                    const newSrc = `${htmlImage?.src?.split("?")[0]}?v=${version}`;
                    htmlImage.src = newSrc;
                    console.log(`Refreshed image: ${newSrc}`);
                });

                // Force reload the page
                // @ts-ignore: Firefox still has a `forceReload` parameter.
                window.location.reload(true);
                console.log("Page reloaded.");
            }
        } catch (error) {
            console.error("Error while clearing storage and reloading the page:", error);
        }

    };


    getGreeting = () => {
        const currentHour = new Date().getHours();

        if (currentHour >= 5 && currentHour < 12) {
            return t("Good Morning");
        } else if (currentHour >= 12 && currentHour < 17) {
            return t("Good Afternoon");
        } else {
            return t("Good Evening");
        }
    };

    renderSurveyQuestion = (chatSize, OnBreak) => {
        if (!utils.isThisMobileDevice() && chatSize <= 1 && !OnBreak && utils.isLiveAdminsCompany(this.state.userData.userLoginData.empCompId)) {
            return <SurveyQuestionTimer chatSize={chatSize} OnBreak={OnBreak} />;
        }
        return "";
    };


    getActiveWindow = () => {
        if (utils.isElectronBuild()) {
            let currentPath = utils.getCurrentPathName()
            let res = localStorage.getItem("childWindowURl");

            if (currentPath == res) {
                sessionStorage.setItem("isParentWindow", "false")
                localStorage.setItem("childWindowURl", "");
                this.setState({ isChildWindow: true })
                // this.setState({ refreshState: new Date()?.toString() })
                // setTimeout(() => {
                //     this.setState({ isChildWindow: true })
                // }, 2000);
            }
            else {
                let _isParentWindow = sessionStorage.getItem("isParentWindow")
                if (_isParentWindow == null || _isParentWindow == undefined) {
                    this.setState({ isChildWindow: false })
                }
                if (_isParentWindow == "true") {
                    this.setState({ isChildWindow: false })
                }

                if (_isParentWindow == "false") {
                    this.setState({ isChildWindow: true })
                }

                // this.setState({ refreshState: new Date()?.toString() })
            }
        }
    }
    RenderChatServerStatus = () => {
        if (utils.isLiveAdminsCompany(this.state.userData?.userLoginData?.empCompId) &&
            utils.isAnyChatPanelActive()
        ) {

            return <span className="strophe-status-box">
                <span
                    title="OpenFire"
                    className="strophe-status XMPP"
                    style={{ background: this.connectionStateColorMap.get(this.state.connectionStatus) }}
                ></span>
                <span
                    title="SignalR"
                    className="strophe-status SignalR"
                    style={{ background: this.connectionStateColorMap.get(this.state.SignalRconnectionStatus) }}
                ></span>
            </span>
        }


    }


    render() {
        return (
            <Navbar className="navbar navbar-expand-lg navbar-light bg-faded">
                <Toast ref={(el) => (this.toast = el)} />
                <div className="container-fluid">
                    <div className="navbar-header">
                        <span className="page-heading page-head-desktop">{this.getHeading()}</span>

                        {!this.state.isChildWindow && <>
                            <Menu size={14} className="navbar-toggle d-xl-none float-left" onClick={this.handleClick} data-toggle="collapse" />
                            <Form className="navbar-form mt-1 float-left" role="search"></Form></>}
                    </div>

                    <div className="navbar-container">
                        {/* {(utils.isOperaterScreenActive() || utils.isChatTranscriptActive()) ? null : <MemoryStats />} */}
                        {!utils.isThisMobileDevice() && <span className="notification-text">
                            {utils.isOperaterScreenActive() && this.state.notificationMessage !== "" ? (
                                <Marquee speed={60}>{this.state.notificationMessage}</Marquee>
                            ) : (""
                                // <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                //     <p style={{ margin: 0 }}>If UI does not load properly, please clear your browser cache or click on Relogin</p>
                                //     <button
                                //         onClick={() => this.clearCache()}
                                //         style={{
                                //             backgroundColor: "red",
                                //             color: "white",
                                //             border: "none",
                                //             padding: "5px 10px",
                                //             fontSize: "12px",
                                //             cursor: "pointer",
                                //             borderRadius: "4px"
                                //         }}
                                //     >
                                //         Relogin
                                //     </button>
                                // </div>
                            )}
                        </span>
                        }

                        {this.renderVideoCallStatus()}
                        {this.RenderChatServerStatus()}
                        {this.RenderPendingSurveyMenu()}
                        {/* {this.renderInternetStatus()} */}
                        {this.renderRefreshIcon()}
                        <Nav className="ml-auto float-right" navbar>

                            <UncontrolledDropdown nav inNavbar className="pr-1">
                                {utils.isDEPCompany(this.state.userData?.userLoginData?.empCompId) && (
                                    <span
                                        className="strophe-status-dep"
                                        style={{ background: this.connectionStateColorMap.get(this.state.connectionStatus) }}
                                    />
                                )}
                            </UncontrolledDropdown>

                            <UncontrolledDropdown nav inNavbar className="pr-1">
                                <DropdownToggle nav>
                                    <span className="user-icons">
                                        {utils.convertStringToCapitalize(this.state.userData?.userLoginData?.username)}
                                        <i className="fa-light fa-user-circle"></i>
                                    </span>
                                </DropdownToggle>

                                <DropdownMenu end>
                                    <DropdownItem>{this.state.userData?.userLoginData?.username}</DropdownItem>
                                    <DropdownItem divider />

                                    {(utils.getCurrentPathName() == OperatorPanelRoute || utils.getCurrentPathName() == monitoringPanelLink) && (
                                        <DropdownItem onClick={() => this.changeBreakStatus()}>
                                            <Coffee size={16} className="mr-2" />{this.state.isOperatorOnBreak ? this.getTitle() : t("take-break")}
                                        </DropdownItem>

                                    )}

                                    <DropdownItem
                                        onClick={() => {
                                            this.setState({ showChangePasswordModal: true });
                                        }}
                                    >
                                        <Key size={16} className="mr-2" />{t("Change Password")}
                                    </DropdownItem>
                                    <DropdownItem divider />
                                    <DropdownItem
                                        onClick={() => {
                                            this.setState({ showSettingsModal: !this.state.showSettingsModal });
                                        }}
                                    >
                                        <Settings size={16} className="mr-2" />{t("Settings")}
                                    </DropdownItem>
                                    <DropdownItem divider />

                                    <DropdownItem divider />
                                    <DropdownItem
                                        onClick={() => {
                                            this.setState({ showReportBugModal: true });
                                        }}
                                    >
                                        <Flag size={16} className="mr-2" />{t("Report a Bug")}
                                    </DropdownItem>
                                    <DropdownItem divider />
                                    <DropdownItem
                                        onClick={() => {
                                            window.location.reload();
                                        }}
                                    >
                                        <RefreshCcw size={16} className="mr-2" />{t("wg-buttons.Refresh")}
                                    </DropdownItem>
                                    <DropdownItem divider />
                                    <DropdownItem onClick={() => this.onBeforeLogout()}>
                                        <LogOut size={16} className="mr-2" />{t("Logout")}
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </Nav>

                        {this.state.showSettingsModal && (
                            <SettingModal
                                onHide={() => this.setState({ showSettingsModal: false })}
                                isChatScreenActive={utils.isChatScreenActive()}
                            />
                        )}
                        {this.state.showChangePasswordModal && (
                            <ChangePasswordModal onClose={() => this.setState({ showChangePasswordModal: false })} />
                        )}
                        {this.state.showLogoutModal && <LogoutModal OnClose={() => this.setState({ showLogoutModal: false, onLogOutMode: false })} />}
                        <div className="text-center">
                            <Modal isOpen={this.state.showSurveyQuestionsModal}>
                                <ModalHeader>{t("Survey.header")}</ModalHeader>
                                <ModalBody>{t("Survey.message")}</ModalBody>
                                <ModalFooter>
                                    <button className="wgbtn p-ripple" onClick={() => this.setState({ showSurveyQuestionsModal: false })}>
                                        <Ripple /> {t("Ok")}
                                    </button>
                                </ModalFooter>
                            </Modal>

                            <Modal isOpen={this.state.sessionExpiredAlert}>
                                <ModalHeader>{t("Session.header")}</ModalHeader>
                                <ModalBody>{t("Session.message")}</ModalBody>
                                <ModalFooter>
                                    <button className="wgbtn p-ripple" onClick={() => this.logOutOnSessionExpired()}>
                                        <Ripple /> {t("Ok")}
                                    </button>
                                </ModalFooter>
                            </Modal>

                            <Modal isOpen={this.state.showUpdateModal}>
                                <ModalHeader>{t("showUpdateModal.header")}</ModalHeader>
                                <ModalBody>{t("showUpdateModal.message")}</ModalBody>
                                <ModalFooter>
                                    <button className="wgbtn p-ripple" onClick={() => this.refresh()}>
                                        <Ripple /> {t("wg-buttons.Refresh")}
                                    </button>
                                </ModalFooter>
                            </Modal>

                            <Modal isOpen={this.state.showPopUpPermissionModal}>
                                <ModalHeader>{t("browserPermissionPopup.heading")}</ModalHeader>
                                <ModalBody>{t("browserPermissionPopup.description")}</ModalBody>
                                <ModalFooter>
                                    <button className="wgbtn p-ripple" onClick={() => this.setState({ showPopUpPermissionModal: false })}>
                                        <Ripple /> {t("wg-buttons.OK")}
                                    </button>
                                </ModalFooter>
                            </Modal>
                        </div>
                        {this.state.showReportBugModal && <ReportABug OnClose={() => this.setState({ showReportBugModal: false })} />}
                        {this.renderSurveyQuestion(this.state.runningChatsCount, this.state.isOperatorOnBreak)}
                        <audio ref={this.audioRef} src="/audio/Incoming_call.wav" loop style={{ visibility: "hidden" }} />
                    </div>

                </div>
                <SnackBar
                    open={this.state.openSnackBar}
                    severity={this.state.severity}
                    message={this.state.responseMessage}
                    handleClose={() => this.setState({ openSnackBar: false })}
                />
            </Navbar>
        );
    }
}

export default NavigationBar;
